import React from "react";
import InventarioReporte from "./InventarioReporte";
export default function ListaSensores() { return <InventarioReporte kind="sensores" />; }
